import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import PopModal from '../../../Constant/Custom/Models/PopModal';
import districtList from '../../../Constant/Json/districts.json';
import autonomousCol from '../../../Constant/Json/autocol-2025.json';
import doteCol from '../../../Constant/Json/dotecol-2025.json';
import stateList from '../../../Constant/Json/states.json';
import { BSC, CHEMICAL, CIVIL, COMPUTER, ELECTRICAL, ELECTRONICS, LEATHER, MECHANICAL, MODERNOFFICE, PRINTING, serverUrl, TEXTILE } from '../../../Constant/Static/config';
import { AuthContext } from '../../../Auth/AuthContext';
import Loader from '../../../Constant/Custom/Loader';


function Academic({ handleNext, handlePrevious }) {
  const { auth, logoutUser } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState({ title: "", text: "", icon: "" });
  const [onConfirm, setOnConfirm] = useState(() => () => { });
  const [onCancel, setOnCancel] = useState(() => () => { });
  const [showCancelButton, setShowCancelButton] = useState(false);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const storedUser = auth.user;
  const [csrfToken, setCsrfToken] = useState("");
  const [errors, setErrors] = useState({});
  const [MarkErrors, setMarkErrors] = useState({});

  // const [markType, setMarkType] = useState("MARKS");

  // const validGrades = ["O", "A+", "A", "B+", "B", "C"];

  // const isGrade = (value) => {
  //   return validGrades.includes(value?.toString().trim().toUpperCase());
  // };

  const isNumericMark = (value) => {
    return /^\d{1,4}$/.test(value?.toString().trim());
  };

  const isObtainedMark = (value) => {
    return /^\d+(\.\d{0,3})?$/.test(value?.toString().trim());
  };

  const [data, setData] = useState([
    { id: 1, study_detail: "", year: "", school: "", district: "", state: "" },
    { id: 2, study_detail: "", year: "", school: "", district: "", state: "" },
    { id: 3, study_detail: "", year: "", school: "", district: "", state: "" },
    { id: 4, study_detail: "", year: "", school: "", district: "", state: "" },
    { id: 5, study_detail: "", year: "", school: "", district: "", state: "" },
  ]);

  const [studyDetailError, setStudyDetailError] = useState({});

  const validateMarksOnBlur = (row) => {

    if (
      isObtainedMark(row.obtainedMarks) &&
      isNumericMark(row.maxMarks)
    ) {

      if (
        parseFloat(row.obtainedMarks) >
        parseInt(row.maxMarks)
      ) {

        setModalType({
          icon: "warning",
          title: "Invalid",
          text: "Maximum marks should be greater than Obtained marks.",
        });

        openModal();
        setOnConfirm(() => closeModal);
      }
    }
  };

  const handleAcademicChange = (e, index, field) => {
    // // console.log(index," ",field);

    const newData = [...data];
    newData[index][field] = e.target.value;
    let isYearValid = true;
    let isStudyValid = true;

    for (let i = 1; i < newData.length; i++) {
      const prevStudy = newData[i - 1].study_detail
        ? studyDetailsOptions[newData[i - 1].study_detail]
        : null;
      const currentStudy = newData[i].study_detail
        ? studyDetailsOptions[newData[i].study_detail]
        : null;

      const prevYear = newData[i - 1].year
        ? parseInt(newData[i - 1].year)
        : null;
      const currentYear = newData[i].year ? parseInt(newData[i].year) : null;
      if (currentYear && prevYear && currentYear <= prevYear) {
        isYearValid = false;
        break;
      }
      if (currentStudy && prevStudy && currentStudy <= prevStudy) {
        isStudyValid = false;
        break;
      }
    }
    if (!isYearValid) {
      const resetData = newData.map((item, idx) => {
        if (idx === index) {
          return { ...item, year: "" };
        }
        return item;
      });
      setData(resetData);
      setModalType({
        icon: "warning",
        title: "Invalid",
        text: "Year of passing Should be Greater than previous year of passing",
      });
      openModal();
      setOnConfirm(() => closeModal);
      setStudyDetailError(
        `The year in record ${index + 1
        } must be greater than all preceding records.`
      );
    } else if (!isStudyValid) {
      const resetData = newData.map((item, idx) => {
        if (idx === index) {
          return { ...item, study_detail: "" };
        }
        return item;
      });
      setData(resetData);
      setModalType({
        icon: "warning",
        title: "Invalid",
        text: "Study details should be in order from lower to higher qualification.",
      });
      openModal();
      setOnConfirm(() => closeModal);
      setStudyDetailError(
        `The Study Detail in record ${index + 1} must be Greater than Previous`
      );
    } else {
      setData(newData);
      setStudyDetailError("");
    }
  };
  const validateStudyDetailForm = () => {
    const newErrors = {};
    data.forEach((item, index) => {
      if (
        !item.study_detail ||
        !item.year ||
        !item.school ||
        !item.district ||
        !item.state
      ) {
        newErrors[index] = "All fields are required";
      }
    });
    // console.log("study error", newErrors);

    setStudyDetailError(newErrors);
    // // console.log('StudyDetail Error',newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const studyDetailsOptions = {
    "9th Std": 1,
    "10th Std": 2,
    "11th Standard": 3,
    "12th Standard": 4,
    "ITI 1st Year": 5,
    "ITI 2nd Year": 6,
    "Diploma 1st Year": 7,
    "Diploma 2nd Year": 8,
    "Diploma 3rd Year": 9,
    "Diploma 4th Year": 10,
    "B.Sc 1st Year": 11,
    "B.Sc 2nd Year": 12,
    "B.Sc 3rd Year": 13,
  };
  let yearOptions = [];
  const currentYear = new Date().getFullYear();
  for (let year = currentYear; year >= 1960; year--) {
    yearOptions.push(year.toString());
  }
  let districtOptions = [];
  if (Array.isArray(districtList)) {
    districtOptions = districtList;
  }
  let stateOptions = [];
  if (Array.isArray(stateList)) {
    stateOptions = stateList;
  }
  let AutoCollegeOptions = [];
  if (Array.isArray(autonomousCol)) {
    AutoCollegeOptions = autonomousCol;
  }
  let DoteCollegeOptions = [];
  if (Array.isArray(doteCol)) {
    DoteCollegeOptions = doteCol;
  }
  const courseTypes = [
    { value: "0", label: "--Select Course Type--", semesters: [] },
    { value: "6", label: "Regular", semesters: [1, 2, 3, 4, 5, 6] },
    { value: "4", label: "Lateral", semesters: [3, 4, 5, 6] },
    {
      value: "7",
      label: "Sandwich (7 Semesters)",
      semesters: [1, 2, 3, 4, 5, 6, 7],
    },
    {
      value: "71",
      label: "Sandwich (8 Semesters)",
      semesters: [1, 2, 3, 4, 5, 6, 7, 8],
    },
    {
      value: "72",
      label: "Sandwich (Lateral - 7 Semesters)",
      semesters: [3, 4, 5, 6, 7],
    },
    {
      value: "73",
      label: "Sandwich (Lateral - 8 Semesters)",
      semesters: [3, 4, 5, 6, 7, 8],
    },
    { value: "8", label: "Part Time", semesters: [1, 2, 3, 4, 5, 6] },
  ];
  const monthOptions = [
    { value: "01", label: "January" },
    { value: "02", label: "February" },
    { value: "03", label: "March" },
    { value: "04", label: "April" },
    { value: "05", label: "May" },
    { value: "06", label: "June" },
    { value: "07", label: "July" },
    { value: "08", label: "August" },
    { value: "09", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];
  const [courseType, setCourseType] = useState("");
  const [rows, setRows] = useState([]);
  const handleCourseTypeChange = (e) => {
    // console.log(rows);
    setRows([])
    const selectedCourse = typeof e === "string" ? e : e.target.value;
    setCourseType(selectedCourse);
    const course = courseTypes.find(
      (course) => course.value === selectedCourse
    );
    if (course) {
      const semesters = course.semesters;
      setRows(
        semesters.map((sem) => ({
          semester: sem,
          month: "",
          year: "",
          obtainedMarks: "",
          maxMarks: "",
        }))
      );
    } else {
      setRows([]);
    }
  };
  const handleRowChange = (index, field, value) => {
    const updatedRows = [...rows];

    updatedRows[index] = {
      ...updatedRows[index],
      [field]: value,
    };

    setRows(updatedRows);
  };
  const validateMarksForm = () => {
    const newErrors = {};

    rows.forEach((row, index) => {

      if (!row.month || !row.year) {
        newErrors[index] = "Month and Year are required";
        return;
      }

      // const obtained = row.obtainedMarks?.toString().trim().toUpperCase();
      const obtained = row.obtainedMarks?.toString().trim();
      const maximum = row.maxMarks?.toString().trim();

      if (!obtained) {
        newErrors[index] = "Obtained Marks is required";
        return;
      }

      // Grade Entry
      // if (isGrade(obtained)) {
      //   return;
      // }

      // Numeric Marks Entry
      if (!isObtainedMark(obtained)) {
        newErrors[index] = "Invalid Obtained Marks";
        return;
      }

      if (!maximum) {
        newErrors[index] = "Maximum Marks is required";
        return;
      }

      if (!isNumericMark(maximum)) {
        newErrors[index] = "Invalid Maximum Marks";
        return;
      }

      // if (parseInt(obtained) > parseInt(maximum)) {
      if (parseFloat(obtained) > parseInt(maximum)) {
        setModalType({
          icon: "warning",
          title: "Invalid",
          text: "Maximum marks should be greater than Obtained marks.",
        });

        openModal();
        setOnConfirm(() => closeModal);

        newErrors[index] =
          "Obtained marks cannot be greater than maximum marks";
      }
    });

    setMarkErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const validateRowChange = (index, field, value) => {

    if (field === "obtainedMarks") {

      if (
        value !== "" &&
        !/^\d+(\.\d{0,3})?$/.test(value)
      ) {
        return;
      }
    }

    if (field === "maxMarks") {

      if (
        value !== "" &&
        !/^\d{0,4}$/.test(value)
      ) {
        return;
      }
    }

    const newRows = [...rows];

    newRows[index][field] = value;

    setRows(newRows);
  };

  //   const handleMarkTypeChange = (e) => {
  //   const selectedType = e.target.value;

  //   setMarkType(selectedType);

  //   if (selectedType === "GRADE") {
  //     setRows(prev =>
  //       prev.map(row => ({
  //         ...row,
  //         obtainedMarks: "",
  //         maxMarks: ""
  //       }))
  //     );
  //   }

  //   if (selectedType === "MARKS") {
  //     setRows(prev =>
  //       prev.map(row => ({
  //         ...row,
  //         grade: ""
  //       }))
  //     );
  //   }
  // };
  const [AcademicFormData, setAcademicFormData] = useState({
    appno: storedUser?.appno || "",
    userName: storedUser?.userName || "",
    email: storedUser?.email || "",
    mobile: storedUser?.mobile || "",
    lastTN: "",
    courseCategory: "",
    mathStudied: "",
    boardStudied: "",
    collegeName: "",
    collegeAddress: "",
    univRegNo: "",
    groupName: "",
    branchName: "",
  });
  const validateField = (name, value) => {
    let errorMessage = "";
    // console.log("Error :", /^[A-Za-z\s\-()]+$/.test(value.trim()));
    // console.log("Error :", AcademicFormData["groupName"] );

    if (name === "lastTN" && value.trim() === "") {
      errorMessage = "Required";
    }
    if (name === "courseCategory" && value.trim() === "") {
      errorMessage = "Please select course category";
    }
    if (name === "mathStudied" && value.trim() === "") {
      errorMessage = "Please select Math Studied or not";
    }
    if (name === "boardStudied" && value.trim() === "") {
      errorMessage = "Please select Board Studied";
    }
    if (name === "collegeName" && value.trim() === "") {
      errorMessage = "Please fill College Name";
    }
    if (name === "collegeAddress" && value.trim() === "") {
      errorMessage = "Please Enter College Address";
    }
    if (name === "univRegNo" && value.trim() === "") {
      errorMessage = "Please Enter Exam Register Number";
    }
    if (name === "groupName" && value.trim() === "") {
      errorMessage = "Please select Group Name";
    }
    if (name === "branchName" && value.trim() === "") {
      errorMessage = "Please select Branch Name";
    }
    if (name === "branchName" && AcademicFormData["groupName"] == "12" && !/^[A-Za-z\s\-()]+$/.test(value.trim())) {
      errorMessage = "Invalid Branch Name";
    }
    return errorMessage;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let updatedData = {
      ...AcademicFormData,
      [name]: value,
    };

    // Reset branch when group changes
    if (name === "groupName") {
      updatedData.branchName = "";
    }

    setAcademicFormData(updatedData);

    let error = validateField(name, value);
    setAcademicFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    if (name === "mathStudied" && value === "N") {
      setModalType({
        icon: "warning",
        title: "Eligiblity Criteria",
        text: "If you did not study Mathematics ,You are not eligible.\nபங்கேற்க, மாணவர்கள் கணிதம் பாடத்தை கட்டாயமாக படித்திருக்க வேண்டும்.நீங்கள் கணிதம் படிக்கவில்லை என தேர்ந்தெடுத்துள்ளதால், இதில் பங்கேற்க தகுதி உங்களுக்கு இல்லை",
      });
      setShowCancelButton(true);
      openModal();
      setOnConfirm(() => logoutUser);
      setOnCancel(() => closeModal);
      setAcademicFormData((prev) => ({
        ...prev,
        mathStudied: "Y",
      }));
    }
    if (name === "courseCategory" && value === "BSC") {
      setAcademicFormData((prev) => ({
        ...prev,
        mathStudied: "",
      }));
      handleCourseTypeChange("6");
    }
    if (name === "boardStudied") {
      setAcademicFormData((prevState) => ({
        ...prevState,
        collegeName: "",
      }));
    }
    if (name === "lastTN" && value === "1") {
      const newData = [...data];
      const resetData = newData.map((item, idx) => {
        if (idx + 1) {
          return { ...item, district: "", state: "TamilNadu" };
        }
        return item;
      });
      setData(resetData);
    }
    if (name === "lastTN" && value === "0") {
      const newData = [...data];
      const resetData = newData.map((item, idx) => {
        if (idx + 1) {
          return { ...item, district: "Others", state: "" };
        }
        return item;
      });
      setData(resetData);
    }
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));
  };
  const validateForm = () => {
    let isValid = true;
    const errors = {};
    if (AcademicFormData.lastTN.trim() === "") {
      errors.lastTN = "Last TN is required";
    }
    if (AcademicFormData.courseCategory.trim() === "") {
      errors.courseCategory = "Course category is required";
    }
    if (courseType.trim() == 0) {
      errors.courseType = "Course Type is required";
    }
    if (
      AcademicFormData.mathStudied.trim() === "" &&
      AcademicFormData.courseCategory === "BSC"
    ) {
      errors.mathStudied = "Math studied status is required";
    }
    if (AcademicFormData.boardStudied.trim() === "") {
      errors.boardStudied = "Board studied is required";
    }
    if (AcademicFormData.collegeName.trim() === "") {
      errors.collegeName = "College name is required";
    }
    // if (AcademicFormData.collegeAddress.trim() === '') {
    //     errors.collegeAddress = "College address is required";
    // }
    if (AcademicFormData.univRegNo.trim() === "") {
      errors.univRegNo = "Exam registration number is required";
    }
    if (AcademicFormData.groupName.trim() === "") {
      errors.groupName = "Group name is required";
    }
    if (AcademicFormData.branchName.trim() === "") {
      errors.branchName = "Branch name is required";
    }
    if (AcademicFormData["groupName"] == "12" && !/^[A-Za-z\s\-()]+$/.test(AcademicFormData.branchName.trim())) {
      errors.branchName = "Invalid Branch Name";
    }

    if (Object.keys(errors).length > 0) {
      isValid = false;
    } else {
      isValid = true;
    }
    // console.log("Form Data:", courseType, isValid, errors);
    setErrors(errors);
    return isValid;
  };
  const setDefaultForm = () => {
    setData([
      {
        id: 1,
        study_detail: "",
        year: "",
        school: "",
        district: "",
        state: "",
      },
      {
        id: 2,
        study_detail: "",
        year: "",
        school: "",
        district: "",
        state: "",
      },
      {
        id: 3,
        study_detail: "",
        year: "",
        school: "",
        district: "",
        state: "",
      },
      {
        id: 4,
        study_detail: "",
        year: "",
        school: "",
        district: "",
        state: "",
      },
      {
        id: 5,
        study_detail: "",
        year: "",
        school: "",
        district: "",
        state: "",
      },
    ]);
    setCourseType("");
    setRows([]);
    setAcademicFormData({
      appno: storedUser?.appno || "",
      userName: storedUser?.userName || "",
      email: storedUser?.email || "",
      mobile: storedUser?.mobile || "",
      lastTN: "",
      courseCategory: "",
      mathStudied: "",
      boardStudied: "",
      collegeName: "",
      collegeAddress: "",
      univRegNo: "",
      groupName: "",
      branchName: "",
    });
  };
  const setForm = (existingData) => {
    setCourseType(existingData.courseType);

    // setMarkType(existingData.markType || "MARKS");

    setData(existingData.studyDetails);
    setRows(existingData.semMarks);

    setAcademicFormData((prevState) => ({
      ...prevState,
      ...existingData.otherDetails,
    }));
  };
  const handleAcademicDetailSubmit = async () => {
    if (!validateForm() || !validateMarksForm() || !validateStudyDetailForm()) {
      setModalType({
        icon: "warning",
        title: "Warning",
        text: "Please Fill All the Required Details Correctly to Proceed.",
      });
      openModal();
      setOnConfirm(() => closeModal);
      // console.log("Form is not valid", errors);
      return;
    } else {
      try {
        setLoading(true);
        // console.log(rows);
        // console.log("ROWS SENT", rows);
        const response = await axios.post(
          `${serverUrl}/api/user/AcademicInfo`,
          {
            studyDetails: data,
            courseType: courseType,
            semMarks: rows,
            // markType: markType,
            AcademicFormData,
          },
          {
            headers: {
              "CSRF-Token": csrfToken,
            },
            withCredentials: true,
          }
        );
        if (response.status === 200) {
          setShowCancelButton(false);
          setModalType({
            icon: "success",
            title: "Success",
            text: "Academic Details are Updated Successfully.",
          });
          openModal();
          setOnConfirm(() => handleNext);
        } else {
          // console.log(response);
        }
      } catch (err) {
        console.error("Failed to store data", err);
      }
      finally {
        setLoading(false)
      }
    }
  };
  useEffect(() => {
    const fetchCsrfToken = async () => {
      try {
        const response = await axios.get(`${serverUrl}/api/csrf-token`, {
          withCredentials: true, // Ensure cookies are sent
        });
        setCsrfToken(response.data.csrfToken); // Set CSRF token
      } catch (error) {
        console.error("Error fetching CSRF token:", error);
      }
    };

    fetchCsrfToken();
  }, []);

  useEffect(() => {
    const fetchUserData = async () => {
      localStorage.setItem("currentSection", 3);
      if (csrfToken) {
        try {
          setLoading(true);
          const userDataFromLocalStorage = auth.user;
          if (userDataFromLocalStorage) {
            const response = await axios.post(
              `${serverUrl}/api/user/loadAcademicInfo`,
              {
                appno: userDataFromLocalStorage.appno,
                userName: userDataFromLocalStorage.userName,
                email: userDataFromLocalStorage.email,
                mobile: userDataFromLocalStorage.mobile,
              },
              {
                headers: {
                  "CSRF-Token": csrfToken, // Use CSRF token
                },
                withCredentials: true,
              }
            );
            if (
              response.status === 200 &&
              response.data.courseType !== null &&
              response.data.otherDetails.lastTN !== null
            ) {
              setForm(response.data);
            } else {
              setDefaultForm();
            }
          }
        } catch (error) {
          console.error("Error fetching user data:", error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchUserData();
  }, [csrfToken]); // Dependency on csrfToken: runs when csrfToken changes

  if (loading) {
    return <Loader />;
  }

  return (
    <section>
      <div className="section-head-container">
        <h2 className="section-title">Academic Information</h2>
        {/* <button className='log-btn button-primary' onClick={handleNext}>Save & Next</button> */}
      </div>
      <h4 className="section-sub-title">Study Details of Last Five Years</h4>
      <div className="lastFiveYearCheck">
        <div>
          <h5>
            Have you studied in TamilNadu for the past five years ? <br />
            <span>
              நீங்கள் கடந்த ஐந்து வருடங்களாக தமிழ்நாட்டில் படித்தீர்களா?
            </span>
          </h5>
        </div>
        <div className="radio-group">
          <label className="radio-container">
            <input
              type="radio"
              name="lastTN"
              value="1"
              checked={AcademicFormData.lastTN === "1"}
              onChange={handleChange}
            />{" "}
            Yes
          </label>
          <label className="radio-container">
            <input
              type="radio"
              name="lastTN"
              value="0"
              checked={AcademicFormData.lastTN === "0"}
              onChange={handleChange}
            />{" "}
            No
          </label>
        </div>
        {errors.lastTN && (
          <span className="Academic-item-incorrect">{errors.lastTN}</span>
        )}
      </div>
      <div className="Instruction">
        <strong>Attention!</strong>{" "}
        <span>Educational details should be in order from</span>{" "}
        <strong>lower to higher qualification</strong>
        <span>.</span>
      </div>
      {/* {studyDetailError && <span className="Academic-item-incorrect">{studyDetailError}</span>} */}
      <div className="study-table-container">
        <table className="responsive-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Study Detail</th>
              <th>Year of Study</th>
              <th>School/College Name</th>
              <th>District</th>
              <th>State</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1}</td>
                <td>
                  <select
                    name="study_detail"
                    value={item?.study_detail || ""}
                    onChange={(e) =>
                      handleAcademicChange(e, index, "study_detail")
                    }
                  >
                    <option value="">--Select--</option>
                    {Object.entries(studyDetailsOptions).map(([option, i]) => (
                      <option key={i} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </td>
                <td>
                  <select
                    name="year"
                    value={item?.year || ""}
                    onChange={(e) => handleAcademicChange(e, index, "year")}
                  >
                    <option value="">--Select--</option>
                    {yearOptions.map((option, i) => (
                      <option key={i} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </td>
                <td>
                  <input
                    type="text"
                    name="school"
                    placeholder="Enter School / College Name"
                    value={item?.school || ""}
                    onChange={(e) => handleAcademicChange(e, index, "school")}
                  />
                </td>
                <td>
                  <select
                    name="district"
                    value={
                      AcademicFormData.lastTN === "0" ? "Others" : item.district
                    }
                    onChange={(e) => handleAcademicChange(e, index, "district")}
                    disabled={AcademicFormData.lastTN === "0"}
                  >
                    <option value="">--Select--</option>
                    {AcademicFormData.lastTN === "1" ? (
                      districtOptions.map((option, i) => (
                        <option key={i} value={option}>
                          {option}
                        </option>
                      ))
                    ) : (
                      <option value="Others">Others</option>
                    )}
                  </select>
                </td>
                <td>
                  <select
                    name="state"
                    value={
                      AcademicFormData.lastTN === "0" ? item.state : "TamilNadu"
                    }
                    onChange={(e) => handleAcademicChange(e, index, "state")}
                    disabled={AcademicFormData.lastTN === "1"}
                  >
                    <option value="">--Select--</option>
                    {stateOptions.map((option, i) => (
                      <option key={i} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </td>
                {studyDetailError[index] && (
                  <td colSpan="6">
                    <span className="Academic-item-incorrect">
                      {studyDetailError[index]}
                    </span>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="academic-detail">
        <div>
          <div>
            <h5>
              Course Category - Diploma/B.Sc:
              <br />
              <span>தொழில்நுட்ப பட்டயப் படிப்பு/ இளங்கலை அறிவியல்</span>
            </h5>
          </div>
          <div>
            <select
              name="courseCategory"
              value={AcademicFormData.courseCategory}
              onChange={handleChange}
            >
              <option value="">--Select--</option>
              <option value="DIP">Diploma</option>
              <option value="BSC">B.Sc</option>
            </select>
          </div>
        </div>
        {errors.courseCategory && (
          <span className="Academic-item-incorrect">
            {errors.courseCategory}
          </span>
        )}
        <div>
          <div>
            <h5>
              Course Type:
              <br />
              <span>படிப்பு வகை</span>
            </h5>
          </div>
          <div>
            <select
              name="courseType"
              value={
                AcademicFormData.courseCategory === "BSC" ? "6" : courseType
              }
              onChange={handleCourseTypeChange}
              disabled={AcademicFormData.courseCategory === "BSC"}
            >
              {courseTypes.map((course) => (
                <option key={course.value} value={course.value}>
                  {course.label}
                </option>
              ))}
            </select>
            <br></br>
          </div>
        </div>
        {errors.courseType && (
          <span className="Academic-item-incorrect">
            {errors.courseType}
          </span>
        )}
        {AcademicFormData.courseCategory === "BSC" && (
          <>
            <div>
              <div>
                <h5>
                  Whether Mathematics is studied one of the Subjects in Degree or +2
                  Level? <br />
                </h5>
              </div>
              <div className="radio-group">
                <label className="radio-container">
                  <input
                    type="radio"
                    name="mathStudied"
                    value="Y"
                    checked={AcademicFormData.mathStudied === "Y"}
                    onChange={handleChange}
                  />
                  <span>Yes</span>
                </label>
                <label className="radio-container">
                  <input
                    type="radio"
                    name="mathStudied"
                    value="N"
                    checked={AcademicFormData.mathStudied === "N"}
                    onChange={handleChange}
                  />
                  <span>No</span>
                </label>
              </div>
            </div>
            {errors.mathStudied && (
              <span className="Academic-item-incorrect">
                {errors.mathStudied}
              </span>
            )}
          </>
        )}
        {/* <div>
                    <div>
                        <h5>Board of the College/ University Studied:<br />
                            <span>படித்த  கல்லூரியின்/ பல்கலைகழகத்தின் வாரியம்</span>
                        </h5>
                    </div>
                    <div>
                        <select
                            name="boardStudied"
                            value={AcademicFormData.boardStudied}
                            onChange={handleChange}
                        >
                            <option selected value="">--Select--</option>
                            {AcademicFormData.courseCategory === "BSC" ? (
                                <option value="UNIVERSITY">UNIVERSITY(TN)</option>
                            ) : (
                                <>
                                    <option value="DOTE">DOTE(TN)</option>
                                    <option value="AUTONOMOUS">AUTONOMOUS(TN)</option>
                                    <option value="UNIVERSITY">UNIVERSITY(TN)</option>
                                    <option value="OTHERS">OTHERS</option>
                                </>
                            )
                            }

                        </select>
                        {errors.boardStudied && <span className='Academic-item-incorrect'>{errors.boardStudied}</span>}
                    </div>
                </div> */}
        <div>
          <div>
            <h5>
              Board of the College/ University Studied:
              <br />
              <span>படித்த கல்லூரியின்/ பல்கலைகழகத்தின் வாரியம்</span>
            </h5>
          </div>
          <div>
            <select
              name="boardStudied"
              value={AcademicFormData.boardStudied}
              onChange={handleChange}
            >
              <option value="">
                --Select--
              </option>
              {AcademicFormData.courseCategory === "BSC" ? (
                <>
                  <option value="UNIVERSITY">UNIVERSITY(TN)</option>
                  <option value="OTHERS">OTHERS</option>
                </>
              ) : (
                <>
                  <option value="DOTE">DOTE(TN)</option>
                  <option value="AUTONOMOUS">AUTONOMOUS(TN)</option>
                  <option value="UNIVERSITY">UNIVERSITY(TN)</option>
                  <option value="OTHERS">OTHERS</option>

                </>
              )}
            </select>
          </div>
        </div>
        {errors.boardStudied && (
          <span className="Academic-item-incorrect">{errors.boardStudied}</span>
        )}
        <div>
          <div>
            {AcademicFormData.boardStudied === "UNIVERSITY" ||
              AcademicFormData.boardStudied === "OTHERS" ? (
              <h5>
                Name of the Polytechnic/ College studied with Address:
                <br />
                <span>
                  படித்த தொழில்நுட்ப கல்லூரி/ கல்லூரியின் பெயர் மற்றும் முகவரி
                </span>
              </h5>
            ) : (
              <h5>
                Name of the Polytechnic/ College studied:
                <br />
                <span>படித்த தொழில்நுட்ப கல்லூரி/ கல்லூரியின் பெயர்</span>
              </h5>
            )}
          </div>
          <div>
            {AcademicFormData.boardStudied === "UNIVERSITY" ||
              AcademicFormData.boardStudied === "OTHERS" ? (
              <>
                <input
                  type="text"
                  name="collegeName"
                  placeholder="Enter College Name With Address"
                  value={AcademicFormData.collegeName}
                  onChange={handleChange}
                />
              </>
            ) : (
              <>
                <select
                  name="collegeName"
                  value={AcademicFormData.collegeName}
                  onChange={handleChange}
                >
                  <option value="">--Select--</option>
                  {AcademicFormData.boardStudied === "AUTONOMOUS"
                    ? AutoCollegeOptions.map((option, i) => (
                      <option key={i} value={`${option.code}-${option.name}`}>
                        {option.code}-{option.name}
                      </option>
                    ))
                    : AcademicFormData.boardStudied === "DOTE"
                      ? DoteCollegeOptions.map((option, i) => (
                        <option key={i} value={`${option.code}-${option.name}`}>
                          {option.code}-{option.name}
                        </option>
                      ))
                      : null}
                </select>
                {/* {errors.collegeName && <span className='Academic-item-incorrect'>{errors.collegeName}</span>} */}
              </>
            )}
          </div>
        </div>
        {errors.collegeName && (
          <span className="Academic-item-incorrect">{errors.collegeName}</span>
        )}

        {/* <div>
                    <div>
                        <h5>Address of the Polytechnic/ College last studied:<br />
                            <span>படித்த தொழில்நுட்ப கல்லூரி/ கல்லூரியின் முகவரி</span>
                        </h5>
                    </div>
                    <div>
                        <input type='text'
                            name='collegeAddress'
                            value={AcademicFormData.collegeAddress}
                            onChange={handleChange}
                            placeholder='Enter Address of the College' />
                        {errors.collegeAddress && <span className='Academic-item-incorrect'>{errors.collegeAddress}</span>}
                    </div>
                </div> */}
        <div>
          <div>
            <h5>
              Diploma/B.Sc Examination Register Number:
              <br />
              <span>தொழில்நுட்ப/ இளங்கலைப் பட்ட பதிவு எண் </span>
            </h5>
          </div>
          <div>
            <input
              type="text"
              name="univRegNo"
              value={AcademicFormData.univRegNo}
              maxLength={16}
              onChange={handleChange}
              placeholder="Enter Exam Register Number"
            />
          </div>
        </div>
        {errors.univRegNo && (
          <span className="Academic-item-incorrect">
            {errors.univRegNo}
          </span>
        )}
        <div>
          <div>
            <h5>
              Group Name Studied:
              <br />
              <span>படித்த துறையின் பெயர் </span>
            </h5>
          </div>
          <div>
            <select
              name="groupName"
              value={AcademicFormData.groupName}
              onChange={handleChange}
            >
              <option value=""> --- Select Your Group --- </option>
              {AcademicFormData.courseCategory === "DIP" ? (
                <>
                  <option value="1">CIVIL</option>
                  <option value="2">MECHANICAL</option>
                  <option value="3">ELECTRICAL</option>
                  <option value="4">ELECTRONICS</option>
                  <option value="5">COMPUTER</option>
                  <option value="6">CHEMICAL</option>
                  <option value="7">TEXTILE</option>
                  <option value="8">LEATHER</option>
                  <option value="9">PRINTING</option>
                  <option value="10">DEPT. OF MODERN OFFICE PRACTICE</option>
                  <option value="12">OTHERS</option>
                </>
              ) : (
                <option value="11">B.Sc</option>
              )}
            </select>
          </div>

          <div>
            <h5>
              Branch Name Studied:
              <br />
              <span>பாடப்பிரிவின் பெயர் </span>
            </h5>
          </div>
          <div>
            {AcademicFormData.groupName === "12" ? (
              <input
                type="text"
                name="branchName"
                value={AcademicFormData.branchName}
                onChange={handleChange}
                placeholder="Enter your branch name"
              />
            ) : (
              <select
                name="branchName"
                value={AcademicFormData.branchName}
                onChange={handleChange}
              >
                <option value=""> --- Select Your Branch --- </option>
                {AcademicFormData.groupName === "1" &&
                  CIVIL.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.id} - {item.name}
                    </option>
                  ))}
                {AcademicFormData.groupName === "2" &&
                  MECHANICAL.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.id} - {item.name}
                    </option>
                  ))}
                {AcademicFormData.groupName === "3" &&
                  ELECTRICAL.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.id} - {item.name}
                    </option>
                  ))}
                {AcademicFormData.groupName === "4" &&
                  ELECTRONICS.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.id} - {item.name}
                    </option>
                  ))}
                {AcademicFormData.groupName === "5" &&
                  COMPUTER.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.id} - {item.name}
                    </option>
                  ))}
                {AcademicFormData.groupName === "6" &&
                  CHEMICAL.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.id} - {item.name}
                    </option>
                  ))}
                {AcademicFormData.groupName === "7" &&
                  TEXTILE.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.id} - {item.name}
                    </option>
                  ))}
                {AcademicFormData.groupName === "8" &&
                  LEATHER.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.id} - {item.name}
                    </option>
                  ))}
                {AcademicFormData.groupName === "9" &&
                  PRINTING.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.id} - {item.name}
                    </option>
                  ))}
                {AcademicFormData.groupName === "10" &&
                  MODERNOFFICE.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.id} - {item.name}
                    </option>
                  ))}
                {AcademicFormData.groupName === "11" &&
                  BSC.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.id} - {item.name}
                    </option>
                  ))}
              </select>
            )}
          </div>
        </div>
        <div>
          <div>
            {errors.groupName && (
              <span style={{ marginLeft: "50%", marginTop: "-80px" }} className="Academic-item-incorrect">{errors.groupName}</span>
            )}
          </div>
          <div>
            {errors.branchName && (
              <span style={{ marginLeft: "50%", marginTop: "-80px" }} className="Academic-item-incorrect">{errors.branchName}</span>
            )}
          </div>
        </div>
      </div>

      {/* <div className="academic-detail">
        <div>
          <div>
            <h5>
              Mark Entry Type:
              <br />
              <span>Enter Marks or Grade</span>
            </h5>
          </div>

          <div className="radio-group">
            <label className="radio-container">
              <input
                type="radio"
                name="markType"
                value="MARKS"
                checked={markType === "MARKS"}
                onChange={handleMarkTypeChange}
              />
              Marks
            </label>

            <label className="radio-container">
              <input
                type="radio"
                name="markType"
                value="GRADE"
                checked={markType === "GRADE"}
                onChange={handleMarkTypeChange}
              />
              Grade
            </label>
          </div>
        </div>
      </div> */}

      <div className="Instruction">
        <strong>Attention!</strong> <span>Maximum marks should be</span>{" "}
        <strong>greater than</strong>
        <span> Obtained mark.</span>
        <strong> Kindly enter the obtained marks first and then enter the maximum marks.</strong>
      </div>



      <div className="marks-table-container">
        <table className="marks-responsive-table">
          <thead>
            <tr>
              <th>
                Semester
                <br />
                <span>(பருவம்)</span>
              </th>
              <th>
                Month of Passing
                <br />
                <span>(தேர்ச்சி பெற்ற மாதம்)</span>
              </th>
              <th>
                Year of Passing
                <br />
                <span>(தேர்ச்சி பெற்ற ஆண்டு)</span>
              </th>
              {/* {markType === "MARKS" ? (
                <> */}
              <th>
                Obtained Marks/GPA
                <br />
                <span>(பெற்ற மதிப்பெண்)</span>
              </th>

              <th>
                Maximum Marks/GPA
                <br />
                <span>(அதிகபட்ச மதிப்பெண்)</span>
              </th>
              {/* </>
              ) : (
                <th>
                  Grade
                  <br />
                  <span>(தரம்)</span>
                </th>
              )} */}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <tr key={index}>
                <td>
                  {row.semester === 1
                    ? "1st Semester"
                    : row.semester === 2
                      ? "2nd Semester"
                      : row.semester === 3
                        ? "3rd Semester"
                        : row.semester + "th Semester"}
                </td>
                <td>
                  <select
                    name="month"
                    value={row.month}
                    onChange={(e) =>
                      handleRowChange(index, "month", e.target.value)
                    }
                  >
                    <option value="">--Select--</option>
                    {monthOptions.map((option, i) => (
                      <option key={i} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </td>
                <td>
                  <select
                    name="year"
                    value={row.year}
                    onChange={(e) =>
                      handleRowChange(index, "year", e.target.value)
                    }
                  >
                    <option value="">--Select--</option>
                    {yearOptions.map((option, i) => (
                      <option key={i} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </td>
                {/* {markType === "MARKS" ? (
                  <> */}
                <td>
                  <input
                    type="text"
                    value={row.obtainedMarks}
                    maxLength={8}
                    onChange={(e) =>
                      validateRowChange(
                        index,
                        "obtainedMarks",
                        e.target.value
                      )
                    }
                  />
                </td>

                <td>
                  <input
                    type="text"
                    value={row.maxMarks}
                    maxLength={4}
                    disabled={!isObtainedMark(row.obtainedMarks)}
                    style={
                      !isObtainedMark(row.obtainedMarks)
                        ? {
                          backgroundColor: "#d1d5db",
                          border: "1px solid #6b7280",
                          color: "#4b5563",
                          cursor: "not-allowed",
                          opacity: 1,
                        }
                        : {}
                    }
                    onChange={(e) =>
                      validateRowChange(
                        index,
                        "maxMarks",
                        e.target.value
                      )
                    }
                    onBlur={() => validateMarksOnBlur(rows[index])}
                  />
                </td>
                {/* </>
                ) : (
                  <td>
                    <select
                      name="grade"
                      value={row.grade || ""}
                      onChange={(e) =>
                        handleRowChange(index, "grade", e.target.value)
                      }
                    >
                      <option value="">--Select Grade--</option>
                      <option value="O">O</option>
                      <option value="A+">A+</option>
                      <option value="A">A</option>
                      <option value="B+">B+</option>
                      <option value="B">B</option>
                      <option value="C">C</option>
                    </select>
                  </td>
                )} */}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <br />
      <div className="next-button">
        <button className="log-btn button-secondary" onClick={handlePrevious}>
          Previous
        </button>
        <button
          className="log-btn button-primary"
          onClick={handleAcademicDetailSubmit}
        >
          Save & Next
        </button>
      </div>
      <div
        style={{
          position: "relative",
          alignSelf: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <PopModal
          isOpen={isModalOpen}
          type={modalType}
          confirmButtonText="OK"
          onConfirm={onConfirm}
          showCancelButton={showCancelButton}
          cancelButtonText="Cancel"
          onCancel={onCancel}
        />
      </div>
    </section>
  );
}

export default Academic;
